export const ROOT = "/admin/lucky-draw-v2";
export const LUCKY_DRAW_CREATE = `${ROOT}/traditional-raffle/new`;
export const INSTANT_WIN_CREATE = `${ROOT}/instant-win/new`;
export const LUCKY_DRAW_DETAIL = `${ROOT}/traditional-raffle/:luckyDrawUUID/`;
export const INSTANT_WIN_DETAIL = `${ROOT}/instant-win/:luckyDrawUUID/`;
export const LD_LIVE_DRAW = `${ROOT}/live-draw/:luckyDrawID`;
export const LUCKY_DRAW_PARTICIPANTS = `${ROOT}/:luckyDrawUUID/participants`;
